import moment from 'moment'
import OpenAIUtils from '@/utils/open-ai/OpenAIUtils'

const SET_PROMPT_SUGGESTIONS = 'SET_PROMPT_SUGGESTIONS'

const _state = {
  promptSuggestions: [],
}

const _getters = {
  promptSuggestions: (state) => state.promptSuggestions,
}

const actions = {
  getPromptSuggestionsAction({ commit, rootState }) {
    const userCountry = rootState.currentUser.country ? rootState.currentUser.country : 'Singapore'
    const userFirstName = rootState.currentUser.firstName ? rootState.currentUser.firstName : 'Lily'
    const userCity = rootState.currentUser.city ? rootState.currentUser.city : 'Paris'
    const nextMonth = moment().add(1, 'months').format('MMMM')
    const economyUserCountry = rootState.currentUser.country ? rootState.currentUser.country : 'Germany'

    const allExamples = [
      `fun facts about ${userCountry}`,
      `introducing ${userFirstName} to the team`,
      `places to visit in ${userCity}`,
      `memorable events in ${nextMonth}`,
      'funny icebreaker questions',
      `economy of ${economyUserCountry}`,
      'active listening',
      'how to be more inclusive',
      'mental health at work',
      'leadership skills training',
    ]

    commit(SET_PROMPT_SUGGESTIONS, OpenAIUtils.getRandomItemsInArray(allExamples, 4))
  },
}

const mutations = {
  [SET_PROMPT_SUGGESTIONS](state, value) {
    state.promptSuggestions = value
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
